import React, { useState, useEffect } from "react";
import { useAuth } from "../../firebase/AuthProvider";
import { Statement } from "../../firebase/statements";
import { getStatements } from "../../firebase/statements";
import { usePrivateUserProfile } from "../profile/usePrivateUserProfile";
import RegionFilter from "./RegionFilter";
import Spinner from "../shared/Spinner";
import { PrivateUserProfile } from "../../firebase/users";
import { Grid } from "@material-ui/core";
import StatementsList, { StatusType } from "./StatementsList";
import MyRegionIcon from "./svg/icon-my-region.svg";
import DashboardSection from "./DashboardSection";
import { useTranslation } from "react-i18next";

export default function RegionalStatements() {
  const { t } = useTranslation();
  const { isAdmin, user } = useAuth();
  const [statements, setStatements] = useState<Statement[]>([]);
  const [locationType, setLocationType] = useState<string | undefined>();
  const userProfile: PrivateUserProfile | null = usePrivateUserProfile(
    user?.id ? user.id : null
  );
  const [status, setStatus] = useState<StatusType>("idle");

  useEffect(() => {
    const fetch = async () => {
      setStatus("loading");

      const allStatements = await getStatements(isAdmin);

      let found = true;
      let filteredStatements = allStatements;
      if (userProfile) {
        const filteredOnContinent = allStatements.filter(
          (statement) => statement.continent === userProfile?.continent
        );
        const filteredOnCountry = allStatements.filter(
          (statement) => statement.country === userProfile?.country
        );
        const filteredOnRegion = allStatements.filter(
          (statement) => statement.region === userProfile?.region
        );
        const filteredOnMunicipality = allStatements.filter(
          (statement) => statement.municipality === userProfile?.municipality
        );

        //TODO Refactor this @#$&! shit as soon as the dashboard functionality is fully complete.
        if (locationType === "continent") {
          found = filteredOnContinent.length > 0;
          filteredStatements =
            filteredOnContinent.length > 0
              ? filteredOnContinent
              : allStatements;
        } else if (locationType === "country") {
          found = filteredOnCountry.length > 0;
          filteredStatements =
            filteredOnCountry.length > 0
              ? filteredOnCountry
              : filteredOnContinent.length > 0
              ? filteredOnContinent
              : allStatements;
        } else if (locationType === "region") {
          found = filteredOnRegion.length > 0;
          filteredStatements =
            filteredOnRegion.length > 0
              ? filteredOnRegion
              : filteredOnCountry.length > 0
              ? filteredOnCountry
              : filteredOnContinent.length > 0
              ? filteredOnContinent
              : allStatements;
        } else if (locationType === "municipality") {
          found = filteredOnMunicipality.length > 0;
          filteredStatements =
            filteredOnMunicipality.length > 0
              ? filteredOnMunicipality
              : filteredOnRegion.length > 0
              ? filteredOnRegion
              : filteredOnCountry.length > 0
              ? filteredOnCountry
              : filteredOnContinent.length > 0
              ? filteredOnContinent
              : allStatements;
        }
      }

      if (!found) setStatus("nothing_found_for_filter");
      else setStatus("done");

      setStatements(filteredStatements);
    };
    fetch();
  }, [isAdmin, locationType, userProfile]);

  if (status === "loading") return <Spinner isVisible={true} />;

  if (!userProfile) return null;

  return (
    <StatementsList statements={statements} status={status}>
      <Grid
        container
        item
        direction="row"
        justify="space-between"
      >
        <DashboardSection
          title={t("dashboard_statements.myregion")}
          icon={MyRegionIcon}
        />

        <Grid item style={{ paddingTop: "12px" }}>
          <RegionFilter
            selectedRegion={locationType}
            setSelectedRegion={setLocationType}
            continent={userProfile.continent}
            country={userProfile.country}
            region={
              userProfile.region && userProfile.region.length > 0
                ? userProfile.region
                : undefined
            }
            municipality={
              userProfile.municipality && userProfile.municipality.length > 0
                ? userProfile.municipality
                : undefined
            }
          />
        </Grid>
      </Grid>
    </StatementsList>
  );
}
